module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "drop-click-container"
  }, [_c('span', {
    staticClass: "drop-click-name",
    class: {
      hover: _vm.hover
    },
    attrs: {
      "title": _vm.selectedName
    }
  }, [_vm._v("\n    " + _vm._s(_vm.selectedName) + "\n    "), _c('div', {
    staticClass: "button-dropdown"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedInternal),
      expression: "selectedInternal"
    }],
    staticClass: "back-dropdown",
    on: {
      "mouseenter": function($event) {
        _vm.triggerMouseEnter(true)
      },
      "mouseleave": function($event) {
        _vm.triggerMouseEnter(false)
      },
      "focus": function($event) {
        _vm.triggerMouseEnter(true)
      },
      "blur": function($event) {
        _vm.triggerMouseEnter(false)
      },
      "change": function($event) {
        _vm.selectedInternal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_vm._l((_vm.items), function(item) {
    return _vm._t("item", null, {
      item: item
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a9754f72!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DropClick.vue
// module id = 123
// module chunks = 2